import { HtmlParser } from '@calendly/html-parser'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'

export const updateStripeCard = ({ stripe, elements, billingAddress, taxId }) => async () => {
  const result = await stripe.createToken(elements.getElement('card'))

  if (result.token?.card?.country === 'US' && !result.token.card.address_zip) {
    return {
      success: false,
      errorMessage: HtmlParser(I18n.t('publisher.billing.checkout.order.steps.payment_method.require_us_zip_code')),
      isTokenError: true
    }
  }

  if (result.error) {
    return { success: false, errorMessage: result.error.message, isTokenError: true }
  }

  const token = result.token

  const [success, response] = await httpRequest({
    url: '/api/billing/subscription/card',
    method: 'PUT',
    data: {
      card_token: {
        id: token.id,
        livemode: token.livemode,
        card: {
          address_zip: token.card.address_zip,
          country: token.card.country,
          last4: token.card.last4,
        }
      },
      billing_information: {
        billing_address: billingAddress,
        vat_number: taxId
      }
    }
  })

  if (!success) {
    return { success, errorMessage: response.message }
  }

  return { success }
}
